/*
* Author: GM
* Component: DataGridHelper
*/


!function ($) {
    "use strict";

    $.fn.dataGrid = function (options) {

        options = $.extend({
            showBorders: false,
            showRowLines: true,
            columnAutoWidth: true,
            export: {
                enabled: false
            },
            headerFilter: {
                visible: true
            },
            filterRow: {
                visible: true
            },
            pager: {
                showInfo: true,
                showPageSizeSelector: true,
                allowedPageSizes: [5, 10, 20]
            },
            paging: {
                pageSize: 10
            },
            remoteOperations: {
                paging: true,
                filtering: true,
                sorting: true,
                summary: true
            }
        }, options);

        return this.dxDataGrid(options);
    };

}(window.jQuery); 
